import { IonCardHeader, IonCardTitle, IonItem, IonRow, IonSpinner } from "@ionic/react";
import { Page }             from "components/Page";
import { SeqChart }         from "components/charts/SeqChart";
import { DvcPage }          from "navigation/DvcPage";
import { RouterMap }        from "navigation/RouterMap";
import { useDeviceConnection } from "functions/Context";
import { Glob, useLoc }        from "functions/Language";
import { IsFromDevice, TYPE_GCR, TYPE_GCRT, TYPE_ICR, TYPE_PLA } from "functions/networking/NetTypes";
import { useLoader }                        from "functions/networking/useLoader";
import { Energy }       from "pages/Details/Energy";
import { Stages }       from "pages/Details/GCRStages";
import { Measurements } from "pages/Details/Measurements";
import { UnitInfo }     from "pages/Details/UnitInfo";
import { FC } from "react";

import { homeOutline } from "ionicons/icons";


const route = RouterMap.overview;

const Component : FC = () => {
  const loc = useLoc(glob);

  const connection = useDeviceConnection();

  const energyLoader = useLoader("Online", null);

  if (connection.seqData.onlineData === null) {
    return <Page title={loc.title} hideBackButton>
      <IonItem lines="none">
        <IonSpinner />&nbsp;{loc.loading}
      </IonItem>
    </Page>
  }

  // else
  return <Page title={loc.title} hideBackButton>
    <IonRow>
      <span className="group" style={{marginBottom: "-3px"}}>
        <UnitInfo.Overview data={connection.seqData.onlineData.Head} />
        {connection.device._type === TYPE_PLA && (!energyLoader.data || IsFromDevice(energyLoader.data, TYPE_PLA)) &&
            (connection.device.Equipment.Data_flash
              ? <Energy.overview />
              : <Energy.table onlineData={energyLoader.data} />
            )
        }
        {connection.IsFrom([TYPE_GCR, TYPE_GCRT, TYPE_ICR]) && <Stages.Overview />}
      </span>
      <span className="group">
        <Measurements.Overview data={connection.seqData.onlineData} />
        <SeqChart chartId={0} connection={connection}>
          <IonCardHeader><IonCardTitle>
            {loc.chart}
          </IonCardTitle></IonCardHeader>
        </SeqChart>
      </span>
    </IonRow>
  </Page>
}


const glob = Glob({
	en: {
		title: "Overview",
		loading: "Loading...",
		chart: "Evolution of measurements",
	},
	cs: {
		title: "Přehled",
		loading: "Načítání...",
		chart: "Průběh hodnot",
	},
	pg: {
		title: "Visão geral",
		loading: "Carregamento...",
		chart: "Progressão de valores",
	},
	es: {
		title: "Visión general",
		loading: "Cargando...",
		chart: "progresión de valores",
	},
} as const);


export const POverview : DvcPage = {
  page: Component,
  path: route,
  title: glob,
  icon: homeOutline
}

